export enum SapSearchStatus {
    INITIALIZING = 'INITIALIZING',
    FETCHING_PRODUCTS = 'FETCHING_PRODUCTS',
    SAVING_WORKFLOW = 'SAVING_WORKFLOW',
    INITIALIZING_WORKFLOW = 'INITIALIZING_WORKFLOW',
    COMPLETED = 'COMPLETED',
    ERROR = 'ERROR'
}
